import React, { useMemo, useState } from 'react';
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Zoom,
    Autocomplete,
    MenuItem,
    Divider,
} from '@mui/material';
import Dropzone from 'react-dropzone';
import { useDropzone } from 'react-dropzone';
import unsplash from '../api/unsplash';
import Upload from '@mui/icons-material/Upload';
import { Close } from '@mui/icons-material';
import GlobalSnackbar from './Snackbar';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const FileUploader = (props) => {
    const [tipologiaAllegati, setTipologiaAllegati] = useState([]);
    const [open, setOpen] = useState(false);
    const { isDragAccept, isDragReject, isFocused } = useDropzone();
    const [files, setFiles] = useState([]);
    const [openSnack, setOpenSnack] = useState(false);
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const [tipologiaSel, setTipologiaSel] = useState(null);
    const [cartellaSel, setCartellaSel] = useState({
        ID: null,
        ID_Figlio: null,
    });
    const [newCartellaName, setNewCartellaName] = useState('');
    const [newSottocartellaName, setNewSottocartellaName] = useState('');
    const [showNewCartella, setShowNewCartella] = useState(false);
    const [showNewSottocartella, setShowNewSottocartella] = useState(false);
    const baseStyle = useMemo(
        () => ({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px',
            borderWidth: 2,
            borderRadius: 2,
            borderColor: '#eeeeee',
            borderStyle: 'dashed',
            backgroundColor: '#fafafa',
            color: '#bdbdbd',
            outline: 'none',
            transition: 'border .24s ease-in-out',
        }),
        []
    );

    const focusedStyle = useMemo(
        () => ({
            borderColor: '#2196f3',
        }),
        []
    );

    const acceptStyle = useMemo(
        () => ({
            borderColor: '#00e676',
        }),
        []
    );

    const rejectStyle = useMemo(
        () => ({
            borderColor: '#ff1744',
        }),
        []
    );

    const folderSectionStyle = {
        marginTop: 14,
        border: '1px solid #d9e2e7',
        borderRadius: 6,
        padding: 12,
        backgroundColor: '#fbfcfd',
    };

    const folderHeaderStyle = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
        marginBottom: 10,
    };

    const folderTitleStyle = {
        margin: 0,
        fontSize: 14,
        fontWeight: 600,
        color: '#155a72',
    };

    const compactActionsStyle = {
        display: 'flex',
        gap: 6,
        flexWrap: 'wrap',
    };

    const inlineCreateStyle = {
        display: 'flex',
        gap: 8,
        marginTop: 10,
        alignItems: 'stretch',
    };

    const canUseFolders =
        props.id > 0 &&
        ['Cliente', 'Sede', 'Medico', 'Lavoratore'].includes(props.colonna);

    const cartelle = useMemo(() => props.cartelle || [], [props.cartelle]);
    const folderPathOptions = useMemo(
        () =>
            cartelle
                .filter((item) => item.ID_Padre === null)
                .flatMap((folder) => [
                    {
                        value: `folder:${folder.ID}`,
                        label: folder.Nome,
                        folderId: folder.ID,
                        subFolderId: null,
                    },
                    ...cartelle
                        .filter((item) => item.ID_Padre === folder.ID)
                        .map((subFolder) => ({
                            value: `folder:${folder.ID}:sub:${subFolder.ID}`,
                            label: `${folder.Nome} / ${subFolder.Nome}`,
                            folderId: folder.ID,
                            subFolderId: subFolder.ID,
                        })),
                ]),
        [cartelle]
    );
    const selectedPathValue =
        cartellaSel.ID === null
            ? ''
            : cartellaSel.ID_Figlio === null
              ? `folder:${cartellaSel.ID}`
              : `folder:${cartellaSel.ID}:sub:${cartellaSel.ID_Figlio}`;

    const handlePathChange = (event) => {
        const option = folderPathOptions.find(
            (item) => item.value === event.target.value
        );

        setCartellaSel({
            ID: option?.folderId || null,
            ID_Figlio: option?.subFolderId || null,
        });
        setShowNewSottocartella(false);
        setNewSottocartellaName('');
    };

    const handleUpload = async () => {
        if (files.length === 0) {
            setSnack({
                severity: 'error',
                messaggio: 'Nessun file selezionato',
            });
            setOpenSnack(true);
        } else if (props.visiteMedicheLavoratore) {
            if (files.length > 1) {
                setSnack({
                    severity: 'error',
                    messaggio: 'Carica solo un file',
                });
                setOpenSnack(true);
            } else {
                const formData = new FormData();
                formData.append('description', props.description);
                formData.append('colonna', props.colonna);
                formData.append('ID', props.id);
                formData.append('colonnaExtra', props.colonnaExtra);
                formData.append('extra', props.extra);
                formData.append(
                    'tipologia',
                    tipologiaSel ? tipologiaSel.ID : null
                );
                formData.append('Cartella', cartellaSel.ID ?? '');
                formData.append('Sottocartella', cartellaSel.ID_Figlio ?? '');
                files.forEach((file) => {
                    formData.append('file', file);
                });
                try {
                    await unsplash.post('caricaDoc', formData, {
                        headers: {
                            'content-type': 'multipart/form-data',
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    });
                    setSnack({
                        severity: 'success',
                        messaggio: 'File caricato con successo',
                    });
                    setOpenSnack(true);
                    if (typeof props.reloadAfterUpload === 'function') {
                        await props.reloadAfterUpload();
                    }
                    setFiles([]);
                    setOpen(false);
                } catch {
                    setSnack({
                        severity: 'error',
                        messaggio: 'Errore durante il caricamento',
                    });
                    setOpenSnack(true);
                }
            }
        } else {
            const formData = new FormData();
            formData.append('colonna', props.colonna);
            formData.append('ID', props.id);
            if (
                props.hasOwnProperty('colonnaExtra') &&
                props.colonnaExtra !== undefined &&
                props.colonnaExtra !== ''
            ) {
                formData.append('colonnaExtra', props.colonnaExtra);
                formData.append('extra', props.extra);
            }

            formData.append('tipologia', tipologiaSel ? tipologiaSel.ID : null);
            formData.append('Cartella', cartellaSel.ID ?? '');
            formData.append('Sottocartella', cartellaSel.ID_Figlio ?? '');
            files.forEach((file) => {
                formData.append('file', file);
            });
            try {
                await unsplash.post('caricaDoc', formData, {
                    headers: {
                        'content-type': 'multipart/form-data',
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                });

                setSnack({
                    severity: 'success',
                    messaggio: 'File caricato con successo',
                });
                setOpenSnack(true);
                if (typeof props.reloadAfterUpload === 'function') {
                    await props.reloadAfterUpload();
                }
                setFiles([]);
                setOpen(false);
            } catch {
                setSnack({
                    severity: 'error',
                    messaggio: 'Errore durante il caricamento',
                });
                setOpenSnack(true);
            }
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const createCartella = async (isSottocartella = false) => {
        const nome = isSottocartella
            ? newSottocartellaName.trim()
            : newCartellaName.trim();

        if (!nome) {
            setSnack({
                severity: 'error',
                messaggio: 'Inserisci il nome della cartella',
            });
            setOpenSnack(true);
            return;
        }

        if (isSottocartella && cartellaSel.ID === null) {
            setSnack({
                severity: 'error',
                messaggio: 'Seleziona prima una cartella padre',
            });
            setOpenSnack(true);
            return;
        }

        try {
            let requestBody = {
                colonna: props.colonna,
                id: props.id,
                nome,
                ID_Padre: isSottocartella ? cartellaSel.ID : null,
            };

            if (props.colonna === 'Sede') {
                requestBody = {
                    ...requestBody,
                    idAzienda: props.extra || props.idAzienda,
                };
            }

            const response = await unsplash.post('cartelle', requestBody, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });

            if (response.data?.error) {
                throw new Error(response.data.error);
            }

            const newId = response.data?.result?.insertId;
            if (newId) {
                setCartellaSel((current) =>
                    isSottocartella
                        ? { ...current, ID_Figlio: newId }
                        : { ID: newId, ID_Figlio: null }
                );
            }

            if (typeof props.reloadAfterUpload === 'function') {
                await props.reloadAfterUpload();
            }

            if (isSottocartella) {
                setNewSottocartellaName('');
                setShowNewSottocartella(false);
            } else {
                setNewCartellaName('');
                setShowNewCartella(false);
                setShowNewSottocartella(false);
            }

            setSnack({
                severity: 'success',
                messaggio: 'Cartella creata con successo',
            });
            setOpenSnack(true);
        } catch {
            setSnack({
                severity: 'error',
                messaggio: 'Errore durante la creazione della cartella',
            });
            setOpenSnack(true);
        }
    };

    const onDrop = (acceptedFiles) => {
        setFiles(acceptedFiles);
    };

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [
            isFocused,
            isDragAccept,
            isDragReject,
            rejectStyle,
            acceptStyle,
            baseStyle,
            focusedStyle,
        ]
    );
    const loadTipologiaAllegati = async () => {
        try {
            let result = await unsplash.get('tipologiaAllegati', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
            });

            setTipologiaAllegati(result.data);
        } catch {
            alert('Errore durante il caricamento');
        }
    };

    const handleChangeTipologia = (e, newValue) => {
        console.log(newValue);
        setTipologiaSel(newValue);
    };

    return (
        <>
            <Button
                className="ButtonMiller"
                startIcon={<Upload />}
                onClick={async () => {
                    await loadTipologiaAllegati();
                    setOpen(true);
                    setFiles([]);
                    setCartellaSel({
                        ID: null,
                        ID_Figlio: null,
                    });
                    setNewCartellaName('');
                    setNewSottocartellaName('');
                    setShowNewCartella(false);
                    setShowNewSottocartella(false);
                }}
            >
                {props.visiteMedicheLavoratore ? 'ASSOCIA IDONEITÀ' : 'CARICA'}
            </Button>

            <Dialog
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <GlobalSnackbar
                    severity={snack.severity}
                    messaggio={snack.messaggio}
                    openSnack={openSnack}
                    handleCloseSnack={handleCloseSnack}
                />
                <DialogTitle>Carica File</DialogTitle>
                <DialogContent>
                    <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles)}>
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps({ style })}>
                                <input {...getInputProps()} />
                                <p>
                                    Trascina e rilascia qui o fai clic per
                                    selezionare i file
                                </p>
                            </div>
                        )}
                    </Dropzone>
                    {props.tipologia && props.colonna === 'Lavoratore' && (
                        <Autocomplete
                            sx={{ marginTop: '5px' }}
                            id="combo-box-demo"
                            options={tipologiaAllegati}
                            fullWidth
                            onChange={(e, newValue) =>
                                handleChangeTipologia(e, newValue)
                            }
                            getOptionLabel={(option) => option.Descrizione}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="tipologia Allegato"
                                />
                            )}
                        />
                    )}
                    {canUseFolders && (
                        <div style={folderSectionStyle}>
                            <div style={folderHeaderStyle}>
                                <p style={folderTitleStyle}>Destinazione</p>
                                <div style={compactActionsStyle}>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() => {
                                            setShowNewCartella((current) => !current);
                                            setShowNewSottocartella(false);
                                        }}
                                    >
                                        Nuova cartella
                                    </Button>
                                    {cartellaSel.ID !== null && (
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={() => {
                                                setShowNewSottocartella(
                                                    (current) => !current
                                                );
                                                setShowNewCartella(false);
                                            }}
                                        >
                                            Nuova sottocartella
                                        </Button>
                                    )}
                                </div>
                            </div>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Percorso"
                                value={selectedPathValue}
                                onChange={handlePathChange}
                            >
                                <MenuItem value="">Fuori cartella</MenuItem>
                                {folderPathOptions.map((option) => (
                                    <MenuItem
                                        key={option.value}
                                        value={option.value}
                                        sx={{
                                            pl: option.subFolderId ? 4 : 2,
                                        }}
                                    >
                                        {option.subFolderId
                                            ? `- ${option.label}`
                                            : option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                            {(showNewCartella || showNewSottocartella) && (
                                <Divider sx={{ my: 1.5 }} />
                            )}
                            {showNewCartella && (
                                <div style={inlineCreateStyle}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Nome cartella"
                                        value={newCartellaName}
                                        onChange={(event) =>
                                            setNewCartellaName(
                                                event.target.value
                                            )
                                        }
                                    />
                                    <Button
                                        variant="contained"
                                        className="ButtonMiller"
                                        onClick={() => createCartella(false)}
                                    >
                                        Crea
                                    </Button>
                                </div>
                            )}
                            {showNewSottocartella && (
                                <div style={inlineCreateStyle}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Nome sottocartella"
                                        value={newSottocartellaName}
                                        onChange={(event) =>
                                            setNewSottocartellaName(
                                                event.target.value
                                            )
                                        }
                                    />
                                    <Button
                                        variant="contained"
                                        className="ButtonMiller"
                                        onClick={() => createCartella(true)}
                                    >
                                        Crea
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}
                    <aside>
                        <h4 style={{ marginTop: '10px', textAlign: 'center' }}>
                            Files
                        </h4>
                        {files?.map((file) => {
                            return (
                                <ul
                                    key={`${file.path || file.name}-${file.size}-${file.lastModified}`}
                                    style={{
                                        textAlign: 'center',
                                        padding: 0,
                                    }}
                                >
                                    {file.path}
                                </ul>
                            );
                        })}
                    </aside>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        mt: 2,
                        justifyContent: 'space-between',
                        px: 2,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Annulla
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Upload />}
                        onClick={handleUpload}
                    >
                        Carica
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default FileUploader;

/*

	const handleUploadTemp = async () => {
		
		const formData = new FormData();
		formData.append('visitaMedica', 58134);
		formData.append('lavoratore', 30201);
		

		files.map((file) => {
			formData.append('file', file);
		});
		try {
			await unsplash.post('caricaDocCrypt', formData, {
				headers: {
					'content-type': 'multipart/form-data',
					Authorization: `Bearer ${localStorage.getItem('jwt')}`,
				},
			});
			setSnack({
				severity: 'success',
				messaggio: 'File caricato con successo',
			});
			setOpenSnack(true);
			//props.reloadAfterUpload();
		} catch {
			setSnack({
				severity: 'error',
				messaggio: 'Errore durante il caricamento',
			});
			setOpenSnack(true);
		}

}

*/
